import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { DevicesList, useDeviceStore } from '@ottobock/remote-update/domain';

import { DevicesTableDataSource } from './devices-table-datasource';
@Component({
  selector: 'remote-update-feature-remote-update-dashboard-devices-table',
  templateUrl: './devices-table.component.html',
  styleUrl: './devices-table.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTableModule, MatPaginatorModule, MatSortModule]
})
export class DevicesTableComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<DevicesList>;
  @Input() devices: DevicesList[] | null = [];
  @Input() totalCount!: number;
  @Output() paginatorReady = new EventEmitter<MatPaginator>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  dataSource = new DevicesTableDataSource([]);
  currentPageIndex = 0;
  currentPageSize = 10;
  store = inject(useDeviceStore);
  router = inject(Router);

  totalDevices = computed(() => this.store.devices().data?.totalCount ?? 0);
  loading = computed(() => this.store.devices().loading);

  displayedColumns = [
    'product_id',
    'product_group',
    'product',
    'installed_firmware',
    'serial_pm',
    'serial_product',
    'in_use',
    'bdk_id'
  ];
  data = computed<DevicesList[]>(() => {
    return this.store.devices().data?.items ?? [];
  });

  ngAfterViewInit(): void {
    this.refreshTable();
    if (this.paginator) {
      this.paginatorReady.emit(this.paginator);
    }
  }

  ngOnChanges(): void {
    this.refreshTable();
  }

  private refreshTable() {
    if (!this.devices) return;

    this.dataSource.setDeviceData(this.devices);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.table) {
      this.table.dataSource = this.dataSource;
    }
  }

  goToDetails(device: DevicesList): void {
    this.router.navigate(['all-devices/details', device.id]);
  }

  handlePageEvent(event: PageEvent) {
    this.currentPageIndex = event.pageIndex;
    this.currentPageSize = event.pageSize;

    this.pageChange.emit(event);
    this.store.loadNextPage(this.currentPageIndex + 1, this.currentPageSize);
  }
}
